<template>
  <el-popover width="fit-content" :hide-after="0" :trigger="trigger">
    <div class="user-info">
      <div class="field">
        <span class="field-label">姓名:</span>
        <span>{{ name }}</span>
      </div>

      <div class="field">
        <span class="field-label">账号:</span>
        <span>{{ account }}</span>
      </div>

      <div class="field">
        <span class="field-label">角色:</span>
        <div>
          <template v-for="(roleId, index) in str2ints(roles)" :key="index" type="primary">
            <span v-if="index !== 0" class="role-split">,</span>
            <el-tag type="primary">{{ roleMap[roleId]?.name }}</el-tag>
          </template>
        </div>
      </div>

      <div class="field">
        <span class="field-label">电话:</span>
        <span>{{ telephone }}</span>
      </div>
    </div>

    <template #reference>
      <el-link type="primary" :underline="false">{{ name }}</el-link>
    </template>
  </el-popover>
</template>

<script setup>
import { roleMap } from '@/views/adminUser/model'
import { str2ints } from '@safety/shared-utils'

defineProps({
  id: Number,
  name: String,
  account: String,
  telephone: String,
  roles: String,
  trigger: {
    type: String,
    default: 'hover'
  }
})
</script>

<style scoped>
.user-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.field {
  display: flex;
}
.field-label {
  margin-right: 10px;
  width: 50px;
  font-weight: bold;
}
.role-split {
  margin-right: 3px;
}
</style>
